import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import CustomButton from "@/components/common/Button";
import { notify } from "@/components/common/Notification";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Tabs } from "antd";
import { Save } from "lucide-react";
import { useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HRMSNavigationRoutes from "../../utils/navigationRoutes";

const EmployeeAddFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;

  const handleSaveAndRedirect = async (formRef: any) => {
    try {
      await formRef.current?.handleSave();

      notify.success("Employee saved successfully");

      navigate("/hrms" + HRMSNavigationRoutes.EMP_LIFECYCLE_LIST);
    } catch (error) {
      notify.error("Failed to save employee");
      console.error("Save error:", error);
    }
  };
  const schemaEmployeeOnboardingTemplate = "employee Onboarding Template hrms";
  const schemaemployeeonbording = "Employee Onboarding";
  const schemadailyworksummarygroup = "Hrms Daily Work Summary Group";
  const schemahrmsempbirthday = "Hrms Emp birthday";
  const schemahrmsemployeeexit = "Hrms Employee Exit";

  const [isEditingDoc] = useState(false);
  const [editingDocRecord] = useState<any>(null);

  const formDetails = useMemo(() => createForm({ validateFirst: true }), []);
  const formJoining = useMemo(() => createForm({ validateFirst: true }), []);
  const formDocuments = useMemo(() => createForm({ validateFirst: true }), []);
  const formAssetIssued = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formEmployment = useMemo(() => createForm({ validateFirst: true }), []);
  const formAttendanceLeaves = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formSalary = useMemo(() => createForm({ validateFirst: true }), []);
  const formPersonalDetails = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formProfile = useMemo(() => createForm({ validateFirst: true }), []);
  const formExit = useMemo(() => createForm({ validateFirst: true }), []);

  const formDetailsRef = useRef<{ handleSave: () => Promise<any> }>(null);
  const formJoiningRef = useRef<{ handleSave: () => Promise<any> }>(null);
  const formDocumentsRef = useRef<{ handleSave: () => Promise<any> }>(null);

  if (isEditMode) {
    formDetails.setInitialValues({ employee_id: id });
    formJoining.setInitialValues({ employee_id: id });
    formDocuments.setInitialValues({ employee_id: id });
    formAssetIssued.setInitialValues({ employee_id: id });
    formEmployment.setInitialValues({ employee_id: id });
    formAttendanceLeaves.setInitialValues({ employee_id: id });
    formSalary.setInitialValues({ employee_id: id });
    formPersonalDetails.setInitialValues({ employee_id: id });
    formProfile.setInitialValues({ employee_id: id });
    formExit.setInitialValues({ employee_id: id });
  }

  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={
          isEditMode ? "Edit Employee Lifecycle" : "Create Employee Lifecycle"
        }
        onBack={() =>
          navigate("/hrms" + HRMSNavigationRoutes.EMP_LIFECYCLE_LIST)
        }
        extra={[
          !isEditMode && (
            <CustomButton
              key="save"
              type="primary"
              icon={<Save size={16} />}
              onClick={() => handleSaveAndRedirect(formDetailsRef)}
            >
              Save
            </CustomButton>
          ),
        ]}
      />

      <Tabs
        style={{ marginTop: 24 }}
        items={[
          {
            key: "1",
            label: "Employee Onboarding Template",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formDetails}
                  schemaName={schemaEmployeeOnboardingTemplate}
                  recordId={id}
                  ref={formDetailsRef}
                />
                {/* per-tab save removed — use header Save */}
              </>
            ),
          },
          {
            key: "2",
            label: "Employee Onboarding ",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formJoining}
                  schemaName={schemaemployeeonbording}
                  recordId={id}
                  ref={formJoiningRef}
                />
                {/* per-tab save removed — use header Save */}
              </>
            ),
          },
          {
            key: "3",
            label: "Daily Work Summary Group",
            children: (
              <div className="p-4">
                <div className="flex flex-col gap-4">
                  <SchemaFormAutoSubmit
                    form={formDocuments}
                    schemaName={schemadailyworksummarygroup}
                    recordId={isEditingDoc ? editingDocRecord?.id : ""}
                    ref={formDocumentsRef}
                  />
                </div>
              </div>
            ),
          },
          {
            key: "4",
            label: "Employee Birthday",
            children: (
              <div className="p-4">
                <div className="flex flex-col gap-4">
                  <SchemaFormAutoSubmit
                    form={formDocuments}
                    schemaName={schemahrmsemployeeexit}
                    recordId={isEditingDoc ? editingDocRecord?.id : ""}
                    ref={formDocumentsRef}
                  />
                </div>
              </div>
            ),
          },
          {
            key: "5",
            label: "Employee Exit",
            children: (
              <div className="p-4">
                <div className="flex flex-col gap-4">
                  <SchemaFormAutoSubmit
                    form={formDocuments}
                    schemaName={schemahrmsempbirthday}
                    recordId={isEditingDoc ? editingDocRecord?.id : ""}
                    ref={formDocumentsRef}
                  />
                </div>
              </div>
            ),
          },
        ]}
      />
    </>
  );
};

export default EmployeeAddFormPage;
